import React, { useMemo } from "react";
import { makeStyles, Theme, createStyles, Typography, Avatar } from "@material-ui/core";
import { observer } from "mobx-react";
import { CheckBold } from "mdi-material-ui";
import clsx from 'clsx';
import { IconName } from "../../stores/models/Icon";
import DynamicIcon from "../../shared/general/components/DynamicIcon";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        thankYou: {
            textAlign: 'center',
            color: theme.palette.action.active,
            padding: theme.spacing(2)
        },
        lineTwo: {
            marginTop: theme.spacing(2),
        },
        avatar: {
            background: 'none',
            margin: 'auto',
            height: 60,
            width: 60,
            marginBottom: theme.spacing(2),
            border: '3px solid',
            borderColor: theme.palette.success.main,
        },
        filled: {
            background: theme.palette.success.main
        },
        icon: {
            color: theme.palette.success.main,
            fontSize: '30px'
        },
        lightIcon: {
            color: theme.palette.common.white,
            fontSize: '35px'
        }
    }));

interface SuccessMessageProps {
    title?: string;
    icon?: IconName;
    filled?: boolean;
    details: React.ReactNode;
}

const SuccessMessage = observer((props: SuccessMessageProps) => {

    /********* React hooks *********/

    const classes = useStyles();
    const avatarClasses = useMemo(() => clsx(classes.avatar, props.filled ? classes.filled : undefined), [props.filled]);
    const iconClasses = useMemo(() => props.filled ? classes.lightIcon : classes.icon, [props.filled]);

    /********* Render *********/

    return (
        <div id='success-message' className={classes.thankYou}>
            <Avatar className={avatarClasses}>
                {props.icon
                    ? <DynamicIcon icon={props.icon} attributes={{ className: iconClasses }} />
                    : <CheckBold className={iconClasses} fontSize={'large'} />
                }
            </Avatar>
            {props.title && <Typography variant="h4">{props.title}</Typography>}
            <Typography variant="h5" className={classes.lineTwo}>
                {props.details}
            </Typography>
        </div>
    );
});

export default SuccessMessage;